import {logEvent} from 'middleware/analytics/utils/logEvent'

import type {ClientOptions} from '@findhotel/sapi'

export const sapiLogger: NonNullable<ClientOptions['logger']> = {
  log(event) {
    logEvent(event.name, {value: event.value}, 'info')
  }
}
